import React from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { useHistory } from 'react-router';
import dashboardOrOnboarding from 'Helpers/dashboardOrOnboarding';

// This step basically just exists to make sure we end the wizard on the same step no matter which path
// the user takes and navigate away cleanly
const NoopFinishStep = () => {
  const { householdResource } = useSimpleHousehold();
  const history = useHistory();

  React.useEffect(() => {
    if (householdResource) {
      history.replace(dashboardOrOnboarding(householdResource));
    }
  }, []);

  return null;
};

export { NoopFinishStep };
